__turbopack_context__.v({
  "contentClassName": "JJ41cq_contentClassName",
  "heroClassName": "JJ41cq_heroClassName",
  "overlayShadow": "JJ41cq_overlayShadow",
});
